
import { Component, OnInit } from '@angular/core';
import { Order, OrderStatus } from '@interfaces/interfaces';
import { OrderLineComponent } from '@micro-components/order-line/order-line.component';
import { orderStatus, orders } from '@mockup_data/skeleton_data';
import { BffApiService } from 'src/app/shared/bff-api.service';

@Component({
  selector: 'app-sales',
  templateUrl: './sales.component.html',
  styleUrls: ['./sales.component.scss'],
  imports: [OrderLineComponent],
})
export class SalesComponent implements OnInit {
  protected readonly orderStatus: OrderStatus[] = orderStatus;
  private orders: Order[] = orders;
  protected filteredOrder: Order[] = this.orders;

  constructor(private bff: BffApiService) {}

  onChange($event: any) {
    const filter = $event.target.value;
    if (!filter || filter == '-1') {
      this.filteredOrder = this.orders;
      return;
    }
    this.filteredOrder = this.orders.filter((order) => order?.status.toLowerCase().includes(filter.toLowerCase()));
  }

  ngOnInit() {
    this.bff.getOrder().subscribe((orders: any) => {
      this.orders = this.filteredOrder = orders;
    });
  }
}
